import React, { useState } from 'react';
import { CallInsightsAnalysis } from '../adherence/types';
import PlaybookAdherenceSection from '../adherence/PlaybookAdherenceSection';
import ManagerReviewPanel from '../adherence/ManagerReviewPanel';
import PlaybookUsagePanel, { SalesPlaybookUsage } from './PlaybookUsagePanel';

interface PlaybookSectionProps {
  sessionId: string;
  callInsights: CallInsightsAnalysis;
  salesPlaybookUsage?: SalesPlaybookUsage;
  isAdmin: boolean;
  onReviewSaved: () => void;
}

const PlaybookSection: React.FC<PlaybookSectionProps> = ({
  sessionId,
  callInsights,
  salesPlaybookUsage,
  isAdmin,
  onReviewSaved,
}) => {
  const [isUsageExpanded, setIsUsageExpanded] = useState(false);
  const [isAnalysisExpanded, setIsAnalysisExpanded] = useState(false);

  return (
    <div className="space-y-4">
      {/* Accordion 1: Actual Playbook Usage */}
      <div className="border border-gray-200 rounded-lg overflow-hidden">
        <button
          onClick={() => setIsUsageExpanded((prev) => !prev)}
          className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left"
          type="button"
        >
          <span className="text-sm font-semibold text-gray-800">Actual Playbook Usage</span>
          <span
            className="text-gray-400 text-xs transition-transform duration-150"
            style={{
              transform: isUsageExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
              display: 'inline-block',
            }}
          >
            &#9660;
          </span>
        </button>
        {isUsageExpanded && (
          <div className="p-4 border-t border-gray-200">
            <PlaybookUsagePanel salesPlaybookUsage={salesPlaybookUsage} />
          </div>
        )}
      </div>

      {/* Accordion 2: AI Coverage Analysis */}
      <div className="border border-gray-200 rounded-lg overflow-hidden">
        <button
          onClick={() => setIsAnalysisExpanded((prev) => !prev)}
          className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors text-left"
          type="button"
        >
          <span className="text-sm font-semibold text-gray-800">AI Coverage Analysis</span>
          <span
            className="text-gray-400 text-xs transition-transform duration-150"
            style={{
              transform: isAnalysisExpanded ? 'rotate(0deg)' : 'rotate(-90deg)',
              display: 'inline-block',
            }}
          >
            &#9660;
          </span>
        </button>
        {isAnalysisExpanded && (
          <div className="p-4 border-t border-gray-200">
            {callInsights?.playbook ? (
              <PlaybookAdherenceSection playbook={callInsights.playbook} />
            ) : (
              <div className="text-center py-8 text-gray-500 bg-gray-50 border border-gray-200 rounded-lg">
                No playbook analysis data available.
              </div>
            )}
          </div>
        )}
      </div>

      {/* Manager review for the entire playbook section */}
      <ManagerReviewPanel
        sessionId={sessionId}
        currentSection="playbook"
        managerReview={callInsights?.manager_review}
        isAdmin={isAdmin}
        onReviewSaved={onReviewSaved}
      />
    </div>
  );
};

export default PlaybookSection;
